import React from 'react';

const StatsCard = ({
  preValue = '',
  title,
  icon,
  iconColor = 'text-primary',
  value,
  progressPercent,
  progressColor = '',
  label = 'Last Month',
  trend = { direction: 'up', value: '0%', color: 'text-success' }
}) => {
  const trendIcon = trend.direction === 'up' ? 'fas fa-caret-up' : 'fas fa-caret-down';

  return (
    <div className="col-sm-6 col-xl-6 col-lg-6">
      <div className="card custom-card">
        <div className="card-body dash1">
          <div className="d-flex">
            <p className="mb-1 tx-inverse">{title}</p>
            <div className="ml-auto">
              <i className={`${icon} fs-20 ${iconColor}`}></i>
            </div>
          </div>
          <div>
            <h3 className="dash-25"><span className='text-12 text-muted mr-1'>{preValue}</span>{value}</h3>
          </div>
          <div className="progress mb-1">
            <div
              className={`progress-bar progress-bar-xs ${progressColor}`}
              style={{ width: `${progressPercent}%` }}
              role="progressbar"
              aria-valuenow={progressPercent}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
          <div className="expansion-label d-flex text-muted">
            <span className="text-muted">{label}</span>
            <span className="ml-auto">
              <i className={`${trendIcon} mr-1 ${trend.color}`}></i>
              {trend.value}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
